import gql from 'graphql-tag'

export async function getDBFile(apollo, companyId, file) {
    const res: any = await apollo.query({
        query: gql`query fileUploadSignedURL($name: String!, $sha256: String, $contentType: String!, $companyId: ID!) {
            fileUploadSignedURL(
                data: { name: $name, sha256: $sha256, contentType: $contentType, companyId: $companyId }
            ) {
                status url key fields
            }
        }`,
        fetchPolicy: 'network-only',
        variables: {
            name: file.name,
            sha256: file.sha256 || undefined,
            contentType: file.type,
            companyId: companyId
        }
    })
    file.status = res.data.fileUploadSignedURL.status
    file.putAction = res.data.fileUploadSignedURL.url
    file.postAction = res.data.fileUploadSignedURL.url
    file.key = res.data.fileUploadSignedURL.key
    file.data = res.data.fileUploadSignedURL.fields


}

export async function getDBFileForGoogleFile(apollo, companyId, file) {
    const res: any = await apollo.query({
        query: gql`query fileUploadSignedURLorGoogleFile($name: String!, $gDriveFileId: String!, $contentType: String!, $companyId: ID!) {
            fileUploadSignedURL(
                data: { name: $name, gDriveFileId: $gDriveFileId, contentType: $contentType, companyId: $companyId }
            ) {
                status url key fields
            }
        }`,
        fetchPolicy: 'network-only',
        variables: {
            name: file.name,
            gDriveFileId: file.googleId,
            contentType: file.type,
            companyId: companyId
        }
    })
    file.status = res.data.fileUploadSignedURL.status
    file.putAction = res.data.fileUploadSignedURL.url
    file.postAction = res.data.fileUploadSignedURL.url
    file.key = res.data.fileUploadSignedURL.key
    file.data = res.data.fileUploadSignedURL.fields
}
